const GEOLOCATION_API = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';
const LEAD_API = 'https://leadapi.crmbytes.com/api/Lead/AddLead';

/**
 * Fetch geolocation data (IP, country, city, state)
 * Falls back to ipify if primary API fails
 */
export const fetchGeolocation = async () => {
  try {
    const res = await fetch(GEOLOCATION_API, { headers: { accept: 'text/plain' } });
    if (!res.ok) throw new Error('Geolocation failed');
    const data = await res.json();
    if (data.isSuccess) return data;
    throw new Error('Geolocation not successful');
  } catch {
    try {
      const res = await fetch('https://api.ipify.org?format=json');
      const { ip } = await res.json();
      return { isSuccess: true, data: { ipAddress: ip }, errorMessage: '', statusCode: 200 };
    } catch {
      return null;
    }
  }
};

/**
 * Submit lead to CRM API
 * @param {Object} formData - { name, email, countryCode, country, contactNumber, message }
 * @param {Object|null} geo - geolocation response from fetchGeolocation
 * @param {Object} extras - { packageTitle, packageAmount } optional
 */
export const submitLead = async (formData, geo, extras = {}) => {
  const dialCode = formData.countryCode
    ? parseInt(formData.countryCode.replace('+', ''), 10)
    : 1;

  // phoneNumber must be numeric only — no dial code, no spaces, no symbols
  const phoneNumber = (formData.contactNumber || '').replace(/\D/g, '');

  const payload = {
    name: formData.name || '',
    email: formData.email || '',
    countryDialCode: dialCode,
    country: formData.country || 'US',
    phoneNumber,
    ipAddress: geo?.data?.ipAddress || '0.0.0.0',
    description: formData.message || '',
    pageUrl: window.location.href,
    city: geo?.data?.cityName || '',
    state: geo?.data?.regionName || '',
    geoLocation: geo ? JSON.stringify(geo) : '',
    packageTitle: extras.packageTitle || '',
    packageAmount: extras.packageAmount || 0,
  };

  try {
    const res = await fetch(LEAD_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', accept: 'text/plain' },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    // 200 — success with customerId
    if (res.status === 200 && data.isSuccess) {
      return { success: true, customerId: data.data?.customerId, message: data.data?.message };
    }

    // 401 — unauthorized (domain not configured)
    if (res.status === 401 || data.statusCode === 401) {
      return { success: false, message: data.message || 'Unauthorized request' };
    }

    // 400 — validation error
    if (res.status === 400 || data.statusCode === 400) {
      return { success: false, message: data.errorMessage || data.data?.message || 'Invalid data submitted' };
    }

    return { success: false, message: data.errorMessage || 'An error occurred. Please try again.' };
  } catch {
    return { success: false, message: 'Network error. Please check your connection and try again.' };
  }
};
